import styled from 'styled-components';

export const FormStyled = styled.form`
  margin: 0 auto;
  margin-top: 40px;
  max-width: 406px;
`;
